import Chip from "components/BlogPage/Common/Chip";
import { Link } from "react-router-dom";
import React from "react";
import "./BlogItemStyles.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react'
const BlogItem = (
  {
    blog: {
      description,
      title,
      createdAt,
      category,
      cover,
      medium,
      id,
      isLegacy,
      contentHtml
    },
  }
) => {
  useEffect(() => {
    AOS.init();
  }, [])

  // Determine if it's a legacy link or internal link
  // Legacy: Explicitly legacy OR has medium link but no HTML content
  const isExternal = (medium && (isLegacy || !contentHtml));

  const CardContent = () => (
    <div className="blogItem-wrap rev">
      <img src={cover} alt="cover" className="blogItem-cover" />
      <Chip label={category} />
      <h3>{title}</h3>
      <p className="blogItem-desc">
        {description}
      </p>
      <footer>
        <div className="blogItem-author">
          <div>
            <p>
              {new Date(createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
        <span className="blogItem-link"> →</span>
      </footer>
    </div>
  );

  if (isExternal) {
    return (
      <a target="_blank" href={medium} className="blogs-link" rel="noreferrer">
        <CardContent />
      </a>
    );
  }

  return (
    <Link to={`/blog/${id}`} className="blogs-link">
      <CardContent />
    </Link>
  );
}
export default BlogItem;
